import { createContext, useContext } from 'react'
import { PopupContextValue } from './types'

export const PopupContext = createContext<PopupContextValue>(undefined)
export const PopupContextProvider = PopupContext.Provider
export const usePopupContext = () => useContext(PopupContext)
